// extracted by mini-css-extract-plugin
module.exports = {"method":"StatusLabel_method__1_FL0"};